import { ShapeProcess } from "@/shapeStorage/shapes/flowchart/process";

export class ShapeTask extends ShapeProcess {
    width = 200;
    height = 128;
}
